import { BadgeCheck } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

/**
 * Badge "Proprietario Verificato" — visibile solo dopo che un admin AgriNexus
 * ha approvato il documento d'identità del proprietario dell'annuncio.
 *
 * Props:
 *  - size: 'xs' | 'sm' | 'md' (default 'sm')
 *  - showLabel: bool — se true mostra "Verificato" accanto all'icona (default true)
 */
export default function VerifiedBadge({ size = 'sm', showLabel = true, className = '' }) {
  const sizes = {
    xs: { icon: 11, pad: 'px-1.5 py-0.5', text: 'text-[9px]' },
    sm: { icon: 12, pad: 'px-2 py-0.5', text: 'text-[10px]' },
    md: { icon: 14, pad: 'px-2.5 py-1', text: 'text-xs' },
  };
  const s = sizes[size] || sizes.sm;
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid="verified-owner-badge"
            className={`inline-flex items-center gap-1 rounded-full ${s.pad} bg-chartreuse/15 text-chartreuse-foreground border border-chartreuse/40 font-bold uppercase tracking-widest ${s.text} ${className}`}
            style={{ color: 'var(--chartreuse-foreground, #2a6207)' }}
          >
            <BadgeCheck size={s.icon} strokeWidth={2.2} className="shrink-0" />
            {showLabel && <span>Verificato</span>}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[240px] text-xs">
          <b>Proprietario Verificato.</b> Documento d'identità controllato manualmente dal team AgriNexus.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
